import React, { Suspense } from 'react';
import { BrowserRouter, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { pdfjs } from 'react-pdf';
import App from './App';
import packageJson from '../package.json';
import './styles/global.scss';
import './i18n';
import Mixpanel from 'services/tracking';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

import { createRoot } from 'react-dom/client';

const env = import.meta.env.VITE_ENV || 'development';

Sentry.init({
  dsn: 'https://132e7613e806cbe6b5b5743e3ea2add2@o4507094863839232.ingest.de.sentry.io/4510283139645520',
  release: 'partner-portal@' + packageJson.version,
  environment: env,
  // integrations: [
  //   Sentry.reactRouterV6BrowserTracingIntegration({
  //     useEffect: React.useEffect,
  //     useLocation,
  //     useNavigationType,
  //     createRoutesFromChildren,
  //     matchRoutes
  //   })
  // ],
  tracesSampleRate: env === 'production' ? 0.01 : 0.1,
  normalizeDepth: 2
});

Mixpanel.init();

// react-i18next requires a Suspense fallback in the component tree since
// translation files are loaded async. In practise they are fetched nearly
// instantly, hence the empty fallback component.

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
